import { get, post } from '../../utils/api'
import { AxiosResponse } from 'axios'

export const fetchModulePage = (
  id: string,
  moduleId: string
): Promise<AxiosResponse> =>
  get(`/courses/courses/${id}/modules/${moduleId}`, {
    include: [
      'lessons',
      'lessons.userLesson',
      'moduleScreens',
      'lessons.lessonRelations',
      'lessons.blocks',
      'lessons.blocks.gallery',
      'lessons.blocks.files',
      'lessons.blocks.links',
      'lessons.blocks.videos',
      'lessons.shortDescription',
      'lessons.theme',
      'lessons.moduleLessons.markers',
    ].join(','),
  })

export const fetchCourseUserState = (id: string): Promise<AxiosResponse> =>
  get(`/courses/courses/${id}/user-state`)

export const joinModule = (id: string, mid: string): Promise<AxiosResponse> =>
  post(`/courses/courses/${id}/modules/${mid}/join`)

export const joinLesson = (id: string, mid: string, lid: string) =>
  post(`/courses/courses/${id}/modules/${mid}/lessons/${lid}/join`)
